import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { usePwText, ResetPasswordForm } from "@/components/PasswordAuth";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { tx } = usePwText();
  const token = params.get("token") || "";
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6 py-16" data-testid="reset-password-page">
      <div className="max-w-sm w-full space-y-6">
        <h1 className="font-serif text-4xl sm:text-5xl">{tx.resetTitle}</h1>
        {token ? <ResetPasswordForm token={token} onDone={() => nav("/login", { replace: true })} />
          : <p className="text-sm text-[#9E2A2B]" data-testid="reset-missing-token">{tx.errors["Reset link is invalid or has expired"] || "Reset link is invalid or has expired"} · <Link to="/login" className="underline">{tx.signin}</Link></p>}
      </div>
    </div>
  );
}
